var SearchService = /** @class */ (function () {
    function SearchService($http, $state, $stateParams, $q, FilterService, CartService) {
        'ngInject';
        this.pageSize = 24;
        this.sortModel = [
            {
                name: 'Best Matches',
                value: '0',
                assending: 'false',
                active: true
            },
            {
                name: 'Newest Products',
                value: '1',
                assending: 'false',
                active: false
            },
            {
                name: 'Popularity',
                value: '2',
                assending: 'false',
                active: false
            },
            {
                name: 'EQP Level',
                value: '3',
                assending: 'false',
                active: false
            },
            {
                name: 'Brand, A-Z',
                value: '4',
                assending: 'true',
                active: false
            },
            {
                name: 'Brand, Z-A',
                value: '4',
                assending: 'false',
                active: false
            },
            {
                name: 'Price, Low to High',
                value: '6',
                assending: 'true',
                active: false
            },
            {
                name: 'Price, High to Low',
                value: '6',
                assending: 'false',
                active: false
            },
            {
                name: 'Name, A-Z',
                value: '5',
                assending: 'true',
                active: false
            },
            {
                name: 'Name, Z-A',
                value: '5',
                assending: 'false',
                active: false
            }
        ];
        this.clickedSearchTerm = '';
        this.recentSearchesModels = [];
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.FilterService = FilterService;
        this.CartService = CartService;
        this.cartId = null;
    }
    SearchService.prototype.getNewRecentSearchModelItem = function (searchString) {
        var _this = this;
        var state = {
            term: searchString,
            ff: searchString,
            fft: 'term'
        };
        var url = this.$state.href('advSearchResults', state, { inherit: false });
        return {
            word: searchString,
            wordType: 'RecentSearches',
            url: url,
            onClickSearchFunction: function () {
                // execute a normal search for the search term type ahead.
                // put it in the model to abstract the search details
                _this.clickedSearchTerm = searchString;
                _this.$state.go('advSearchResults', state); // switch views to the results page.
            }
        };
    };
    SearchService.prototype.getRecentSearches = function () {
        var _this = this;
        this.recentSearchesModels = [];
        var cartId = this.CartService.cartId;
        this.$http.get('api/search/recent' + (cartId ? "?cartId=" + cartId : ''))
            .then(function (response) {
            if (response.data.response && response.data.response.length) {
                response.data.response.forEach(function (item) {
                    _this.recentSearchesModels.push(_this.getNewRecentSearchModelItem(item));
                });
            }
        })
            .catch(function (err) {
            return _this.$q.reject(err);
        });
    };
    /**
     * Accept state parameter and parse to search api request parameter.
     * Example Input: {'ff': '2', 'fft':'b', 'term': 'fish' , 'a': 1, 'q': 'Gold'}
     * Returns: {'term':'fish', 'attributes': [1], 'eqpStatuses': ['Gold']}
     * @param {Object} params
     * @return {Object}
       */
    SearchService.prototype.mapSearchParameter = function (params) {
        var arrayLikeParameterDict = {
            'a': 'attributes',
            'b': 'brands',
            'c': 'categories',
            'd': 'conditions',
            's': 'subcategories',
            'dc': 'dietaryConsiderations',
            'df': 'deliveryFormat',
            'ds': 'dosages',
            'q': 'eqpStatuses',
            'ii': 'includeIngredients',
            'ei': 'excludeIngredients'
        };
        // landing page search
        if (params.hasOwnProperty('searchFilter')) {
            var queryData = {
                pageSize: this.pageSize,
                searchTerm: '*',
                pageNumber: 1,
            };
            var paramKeyVal = params.searchFilter.substring(params.searchFilter.lastIndexOf('-') + 1).split('');
            paramKeyVal[0] = paramKeyVal[0].toLowerCase();
            paramKeyVal[1] = paramKeyVal.splice(1, paramKeyVal.length - 1).join('');
            if (arrayLikeParameterDict.hasOwnProperty(paramKeyVal[0])) {
                switch (paramKeyVal[0]) {
                    case 'a':
                    case 'b':
                    case 'c':
                    case 'd':
                    case 's':
                        paramKeyVal[1] = parseInt(paramKeyVal[1]);
                        break;
                }
                queryData[arrayLikeParameterDict[paramKeyVal[0]]] = [paramKeyVal[1]];
            }
            return queryData;
        }
        else { // advanced filter search
            var stringLikeParameterDict_1 = {
                'term': { name: 'searchTerm', defaultValue: '*' },
                'sort': { name: 'sortOrder', defaultValue: '0' },
                'order': { name: 'isSortAscending', defaultValue: false },
                'page': { name: 'pageNumber', defaultValue: '1' },
                'new': { name: 'isNewProduct', defaultValue: null }
            };
            // map URI parameter to search data
            var queryData_1 = { 'pageSize': this.pageSize };
            Object.keys(stringLikeParameterDict_1)
                .forEach(function (key) {
                // map search term, sort and page to their string value, it value is undefined, return default value
                queryData_1[stringLikeParameterDict_1[key].name] = params[key]
                    ? params[key]
                    : stringLikeParameterDict_1[key].defaultValue;
            });
            Object.keys(arrayLikeParameterDict)
                .forEach(function (key) {
                if (typeof (params[key]) === 'string') {
                    // single-value parameter needs to be converted into array
                    queryData_1[arrayLikeParameterDict[key]] = [params[key]];
                }
                else {
                    // multi-value parameter is an array
                    queryData_1[arrayLikeParameterDict[key]] = params[key];
                }
            });
            if (queryData_1['isNewProduct']) {
                queryData_1['isNewProduct'] = !!queryData_1['isNewProduct'];
            }
            // convert isSortAscending into boolean
            queryData_1['isSortAscending'] = queryData_1['isSortAscending'] === 'true';
            return queryData_1;
        }
    };
    /**
     *  Search request accept state parameter 'term', 'sort', 'page', etc. as arguments and parses them into query data
     *  that matches POST /search API.
     *  Example Input:
     *   searchParameter = {
     *     'term':'fish oil',
     *     'page': '1',
     *     'b': ['24', '25', '26']
     *     'c': ['3']
     *   }
     *   @param {object} searchParameter
     *   @return {promise}
     */
    SearchService.prototype.searchRequest = function (searchParameter) {
        var _this = this;
        var searchData = this.mapSearchParameter(searchParameter);
        var cartId = this.CartService.cartId;
        return this.$http.post('api/search' + (cartId ? "?cartId=" + cartId : ''), searchData, { cache: true })
            .then(function (response) {
            if (response.data && response.data.errors.length) {
                return response.data.errors[0].message;
            }
            else {
                return response.data.response;
            }
        }).catch(function (err) {
            return _this.$q.reject(err);
        });
    };
    SearchService.prototype.isMobileDevice = function () {
        return (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };
    return SearchService;
}());
export { SearchService };
//# sourceMappingURL=search.service.js.map